import React from 'react'
import { Container, Table } from 'reactstrap';

import File from 'react-icons/lib/md/insert-drive-file'

import '../styles/documents.css'


class Documents extends React.Component {

    render() {
    	const { user } = this.props

    	return (
             <Container>

             	<div className="provider-bloc provider-profile page-document page-provider">
                	<div className="title">4 documents</div>

                	<div className="provider-profile-bloc">

                		 <Table className="table-document">
	                        <tbody>
	                              <tr className="first">
	                              	<td>Nom</td>
	                              	<td>Format</td>
	                              	<td>Date de mise à jour</td>
	                              	<td>Télécharger</td>
	                              </tr>

	                              <tr>
	                              		<td>Modèle de devis</td>
		                              	<td>Word</td>
		                              	<td>15/06/2017</td>
		                              	<td><div className="table-document-active item-doc"> <a href="" target="_blank" rel="noopener noreferrer"> <File size="24"/> Télécharger</a> </div></td>
	                              </tr>

	                              <tr>
	                              		<td>Modèle de facture</td>
		                              	<td>Word</td>
		                              	<td>15/06/2017</td>
		                              	<td><div className="table-document-active item-doc"> <a href="" target="_blank" rel="noopener noreferrer"> <File size="24"/> Télécharger</a> </div></td>
	                              </tr>

	                              <tr>
	                              		<td>Présentation de la société</td>
		                              	<td>PDF</td>
		                              	<td>15/06/2017</td>
		                              	<td><div className="table-document-active item-doc"> <a href="" target="_blank" rel="noopener noreferrer"> <File size="24"/> Télécharger</a> </div></td>
	                              </tr>

	                              <tr>
	                              		<td>Brochure</td>
		                              	<td>PDF</td>
		                              	<td>15/06/2017</td>
		                              	<td><div className="table-document-active item-doc"> <a href="" target="_blank" rel="noopener noreferrer"> <File size="24"/> Télécharger</a> </div></td>
	                              </tr>
	                        </tbody>
	                    </Table>
                	</div>
                </div>
            </Container>
        )
    }
}


export default Documents



// WEBPACK FOOTER //
// ./src/btoc/components/Documents.js